// 自定义table
<template>
  <div class="customTable-wrap">
    <el-table ref="customTable" v-bind="$attrs" :data="tableData" v-on="$listeners">
      <template v-for="(item, index) in column">
        <!-- 正常表格项 -->
        <el-table-column v-if="isNullFun(item.slotName) && isNullFun(item.render) && isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
        </el-table-column>
        <!--  只有render -->
        <el-table-column v-if="isNullFun(item.slotName) && !isNullFun(item.render) && isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
          <template slot-scope="scope">
            <ex-slot :column="item" :index="index" :render="item.render" :row="scope.row" />
          </template>
        </el-table-column>
        <!--  只有 slotHeader-->
        <el-table-column v-if="isNullFun(item.slotName) && isNullFun(item.render) && !isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
          <template slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 只有 slotName -->
        <el-table-column v-if="!isNullFun(item.slotName) && isNullFun(item.slotHeader) && isNullFun(item.render)"
          :key="index + '_' + item.prop" v-bind="item" :align="item.align | alignFilter">
          <template slot-scope="scope">
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!--  render 和 slotHeader-->
        <el-table-column v-if="isNullFun(item.slotName) && !isNullFun(item.render) && !isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
          <template v-if="!isNullFun(item.slotHeader)" slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <ex-slot :column="item" :index="index" :render="item.render" :row="scope.row" />
          </template>
        </el-table-column>
        <!-- slotName 和 slotHeader -->
        <el-table-column v-if="!isNullFun(item.slotName) && !isNullFun(item.slotHeader) && isNullFun(item.render)"
          :key="index + '_' + item.prop" v-bind="item" :align="item.align | alignFilter">
          <template slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 带转换方法 render slotName-->
        <el-table-column v-if="!isNullFun(item.slotName) && !isNullFun(item.render) && isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
          <template slot-scope="scope">
            <ex-slot :column="item" :index="index" :render="item.render" :row="scope.row" />
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 带转换方法 render slotName slotHeader-->
        <el-table-column v-if="!isNullFun(item.slotName) && !isNullFun(item.render) && !isNullFun(item.slotHeader)"
          v-bind="item" :key="index + '_' + item.prop" :align="item.align | alignFilter">
          <template v-if="!isNullFun(item.slotHeader)" slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <ex-slot :column="item" :index="index" :render="item.render" :row="scope.row" />
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrap" v-if="showPages">
      <!-- 其他信息 -->
      <slot name="other"></slot>
      <el-pagination background layout="sizes,total, prev, pager, next, jumper" :page-sizes="pageSize" :total="total"
        :page-size="currentPageSize" :current-page="current" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>
<script>
let exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
    showPages: {//是否显示分页
      type: Boolean,
      default: true
    }
  },
  render(h, data) {
    const params = {
      row: data.props.row,
      index: data.props.index,
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  },
};
import {
  isNull,
  isFuntion,
  isEmptyArray,
  isArray,
  isNumber
} from "@/utils/validateBase";

export default {
  name: "customTable",
  components: { exSlot },
  props: {
    // 是否显示分页信息
    showPages: {
      type: Boolean,
      default: true,
    },
    // 表头数据
    column: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    // 表格数据
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 每页条数配置
    pageSize: {
      type: Array,
      default() {
        return [10, 20, 30, 40];
      },
    },
    currentPageSize: {
      type: Number,
      default() {
        return 10
      }
    },
    // 总页数
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    // 当前页码
    currentPage: {
      type: Number,
      // required: true,
      default: 1
    },
  },
  filters: {
    /**
     * 没有设置align 默认为center
     * **/
    alignFilter(val) {
      if (isNull(val)) return "center";
      return val;
    },
  },
  watch: {
    /**
     * 根据总条数 计算总页数
     */
    total: {
      deep: true,
      immediate: true,
      handler(val) {
        this.pagesNumber = Math.ceil(val / this.size);
      },
    },
    /**
     * 每页条数配置 计算总页数
     * */
    pageSize: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!isNull(val) && isArray(val) && !isEmptyArray(val)) {
          this.size = val[0] * 1;
          this.pagesNumber = Math.ceil(this.total / this.size);
        }
      },
    },
    /**
     * 页码监听
     * */
    currentPage: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!isNull(val) && isNumber(val) && val !== this.current) {
          this.current = val
        }
      }
    },
    currentPageSize: {
      deep: true,
      immediate: true,
      handler(val) {
        this.size = val
      }
    },

  },
  data() {
    return {
      size: 10, // 每页条数
      current: 1, // 当前页码
      pagesNumber: 1, // 总页数
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 是否为空
     * str 数据
     * */
    isNullFun(str) {
      return isNull(str);
    },
    /**
     * 是否是方法
     * str 数据
     * */
    isFuntionFun(str) {
      return isFuntion(str);
    },
    /**
     * 分页数量点击事件
     * val 点击的页面
     * */
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.size = val;
      this.$emit("pageChange", {
        size: val,
        current: this.current,
      });
    },
    /**
     * 分页按钮点击事件
     * 切换后的页码
     * */
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.current = val;
      this.$emit("pageChange", {
        size: this.size,
        current: val,
      });
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-table__body {
  tr:hover>td {
    background-color: #F6F7F8;
  }
}

.pagination-wrap {
  padding: 20px 0 20px 20px;
  text-align: right;
}

/deep/.el-table__row {
  height: 40px;
}

/deep/.el-table td {
  padding: 0;
}

/deep/.el-table .cell {
  white-space: nowrap;
}
</style>
